<template>
  <div class="auth-form-container">
    <internal-loading v-if="internalLoading"></internal-loading>
    <div class="auth-form" id="form-builder"></div>
    <el-button @click="onSubmit" class="auth-button">REDEFINIR</el-button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import internalLoading from '../../shared/loading/InternalLoading'

export default {
  name: 'FormRecuperarSenha',
  components: {
    internalLoading
  },
  data () {
    return {
      form: null,
      internalLoading: true,
      title: 'Recuperar senha',
      buttonBack: true,
      routerName: 'FormLogin'
    }
  },
  mounted () {
    let params = {
      identifier: 'form-builder',
      clientKey: process.env.VUE_APP_CLIENTE_KEY,
      idForm: this.idsforms.formRecuperaSenha,
      colors: {
        primary: '#0075EA',
        errors: '#ff4949'
      }
    }
    this.form = renderForm(params)
    this.form.on('LOADING', res => {
      this.internalLoading = res
    })
  },
  methods: {
    ...mapActions('login', [
      'recuperaSenha',
      'getIds'
    ]),

    onSubmit () {
      this.form.validateAll().then(form => {
        this.recuperaSenha({ token: this.$route.query.token, form: form.data })
      })
    }
  },
  computed: {
    ...mapState('login', [
      'contexto',
      'loading',
      'idsforms'
    ])
  },
  created () {
    this.$root.$emit('set-data-auth', {
      title: this.title,
      subTitle: this.subTitle,
      buttonBack: this.buttonBack,
      routerName: this.routerName
    })
    this.getIds()
  }
}
</script>
<style lang="sass" scoped>
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../../../views/auth/auth.scss'
</style>
